var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Verlängerungsanfrage bearbeiten"),
      confirmText: _vm.$gettext("Speichern"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
      height: "350",
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.updateRenewal,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Fristverlängerung")) +
                      "\n                "
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.state,
                          expression: "state",
                        },
                      ],
                      on: {
                        change: function change($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.state = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "declined",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$gettext("ablehnen")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "granted",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$gettext("gewähren")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.state === "granted"
                  ? _c(
                      "label",
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$gettext("neue Frist")) +
                            "\n                "
                        ),
                        _c("DateInput", {
                          staticClass: "size-l",
                          model: {
                            value: _vm.date,
                            callback: function callback($$v) {
                              _vm.date = $$v
                            },
                            expression: "date",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }